import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";

export const EMPTY_FILTERS = { min_price: "", max_price: "", location: "", condition: "", sort: "newest" };
const URL_KEYS = { min_price: "min", max_price: "max", location: "loc", condition: "cond", sort: "sort" };
const FILTER_KEYS = Object.keys(URL_KEYS);

const readFilters = (sp) => Object.fromEntries(FILTER_KEYS.map((k) => [k, sp.get(URL_KEYS[k]) || EMPTY_FILTERS[k]]));

const toUrlParams = (f) => Object.fromEntries(
  FILTER_KEYS.filter((k) => f[k] && f[k] !== EMPTY_FILTERS[k]).map((k) => [URL_KEYS[k], f[k]])
);

const toApiParams = (slug, f) => ({
  limit: 60,
  category: slug || undefined,
  ...Object.fromEntries(FILTER_KEYS.filter((k) => f[k]).map((k) => [k, f[k]])),
});

export function useListingSearch(slug) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState(() => readFilters(searchParams));
  const [result, setResult] = useState({ items: [], total: 0 });

  useEffect(() => {
    api.get("/listings", { params: toApiParams(slug, filters) })
      .then(({ data }) => setResult({ items: data.items || [], total: data.total || 0 }));
  }, [slug, filters]);

  const applyFilters = useCallback((next) => {
    setFilters(next);
    setSearchParams(toUrlParams(next));
  }, [setSearchParams]);

  return { ...result, filters, applyFilters };
}
